export enum TaskFlaggedStatus {
  Flag1,
  Flag2
}



// WEBPACK FOOTER //
// ./src/app/shared/models/task-flagged-status.ts